import { render, staticRenderFns } from "./errors.vue?vue&type=template&id=4d1a15e9&"
import script from "./errors.vue?vue&type=script&lang=ts&"
export * from "./errors.vue?vue&type=script&lang=ts&"
import style0 from "./errors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports